export default "__VITE_ASSET__BIcAWA5P__"